import { Actions } from "../../common/types";

export function useActions() {
  const associate: Actions["associate"] = (actionId, actionFunction) => {
    // TODO: implement
    console.log(actionId, actionFunction);
  };

  return {
    associate,
  };
}
